import { getState, patchState, signalStore, withComputed, withMethods, withState } from "@ngrx/signals";
import { PayerItem } from "../models/payer-item";
import { computed, inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UtcDateTimeFormatter } from "../helpers/utc-datetime-formatter";
import { HttpEventType } from "@angular/common/http";
import { FileDataService } from "../services/file-upload/file-data.service";
import { FileTypeFilterStore } from "./file-type-filter.store";

type FileDataUploadState = {
    currentFile: File | null;
    selectedPayer: PayerItem | null;
    fileTypeId: number | null;
}

const initialState: FileDataUploadState = {
    currentFile: null,
    selectedPayer: null,
    fileTypeId: null,
}

export const FileDataUploadStore = signalStore(
    withState(initialState),
    withComputed((state) => ({
        formValid: computed(() => state.currentFile() && state.selectedPayer() && (state.fileTypeId() ? state.fileTypeId() > 0 : false)),
    })),
    withMethods((
        store,
        fileService = inject(FileDataService), 
        snackbar = inject(MatSnackBar), 
        dateFormatter = inject(UtcDateTimeFormatter),
        filterStore = inject(FileTypeFilterStore),
    ) => ({
        setCurrentFile(input: File | null) {
            patchState(store, { currentFile: input });
        },
        async setSelectedPayer(input: PayerItem | null) {
            patchState(store, { selectedPayer: input });
            await filterStore.getMapFileTypesByPayerId(input?.ID ?? null);
        },
        setSelectedFileType(input: number | null) {
            patchState(store, { fileTypeId: input });
        },
        async uploadCurrentFile() {
            const state = getState(store);
            if (!state.currentFile || !state.selectedPayer || !state.fileTypeId) return;

            const formData = new FormData();
            const fileId = dateFormatter.getUTCStringFormattedForFileName(new Date()) + state.currentFile.name;
            
            formData.append('file', state.currentFile, fileId);
            formData.append('payerAlias', state.selectedPayer.Abbreviation);
            formData.append('payerIdString', state.selectedPayer.ID.toString());
            formData.append('fileTypeId', state.fileTypeId.toString());          

            try {
                const event = await fileService.uploadFile(formData).toPromise();
                if (event.type === HttpEventType.Response) {
                    patchState(store, 
                        {
                            currentFile: null,
                            selectedPayer: null,
                            fileTypeId: 1
                        });
                    snackbar.open(`File successfully uploaded!`, undefined, {duration: 3000});
                    return true;
                }
            } catch (error) {
                snackbar.open(`Failed to upload.`, undefined, {duration: 3000});
                return false;
            }
        },
        resetState() {
            patchState(store, initialState);
        },
    })),
);